import { CircularProgress, TablePagination } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { invokeApi } from "../../../../bl_libs/invokeApi";
import DoneRequestFilter from "./DoneRequestFilter";
import moment from "moment";
import { withRouter } from "react-router-dom";

function DoneRequests(props) {
  const [requests, SetRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //filter state management
  const [filters, setFilters] = useState(
    localStorage.getItem("foremanReqDoneFilter")
      ? JSON.parse(localStorage.getItem("foremanReqDoneFilter"))
      : {
          from_date: "",
          to_date: "",
          schedule: "",
          distance: "",
          move_type: "",
          total_hours: "",
          request_timeline_status: props.status,
        }
  );
  const [moveSizeList, setMoveSizeList] = useState([]);
  const [truckList, setTruckList] = useState([]);

  const [isFilter, setIsFilter] = useState(
    localStorage.getItem("foremanReqDoneFilter") ? true : false
  );

  //------------------------------------------>  pagination settings

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalCount, setTotalCount] = useState(0);

  //----------------------------------------------------------------

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //////////////////////////////////////////////////////////////////

  const fetchDoneRequests = (type) => {
    let requestObj = {
      path: `/api/foreman/get_foreman_request?page=${page}&limit=${rowsPerPage}`,
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {};
    if (type === "filter" || props.status!=="") {
      setIsFilter(true);
      postData = {
        request_status: "1",
        filter_status: "1",
        from_date:
          filters.from_date === ""
            ? ""
            : moment(filters.from_date).format("MM-DD-YYYY"),
        to_date:
          filters.to_date === ""
            ? ""
            : moment(filters.to_date).format("MM-DD-YYYY"),
        time: filters.schedule,
        min_distance:
          filters.distance === "" ? "" : filters.distance.split("-")[0],
        max_distance:
          filters.distance === "" ? "" : filters.distance.split("-")[1],
        move_type: filters.move_type,
        total_hour: filters.total_hours,
        request_timeline_status:props.status
      };
    } else {
      setIsFilter(false);
      //if type is undefined
      //we are not passing filters in API
      postData = {
        request_status: "1",
      };
    }
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        props.setCounts({
          ...props.counts,
          activeCount: res.request_count.active_request_count,
          doneCount: res.request_count.done_request_count,
          cancelCount: res.request_count.cancle_request_count
        });
        SetRequests(res.data);
        setTotalCount(res.get_request_count);
        setIsLoading(false);
      }
    });
  };

  const fetchTruckList = () => {
    let requestObj = {
      path: "/api/foreman/get_truck_for_foreman",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res.data);
        setTruckList(res.data.allTruck);
      }
    });
  };

  const fetchListForMoverType = () => {
    let requestObj = {
      path: "/api/customer/get_move_type",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "MOVE SIZE RESPONSCE");
      if (res.code === 200) {
        setMoveSizeList(res.data.moveTypeItems);
      }
    });
  };

  const getTotalHours = (move_time) => {
    let total_time = 0;
    move_time.map((time) => {
      total_time += parseInt(time.total_hours);
    });

    return total_time;
  };

  useEffect(() => {
    if (isFilter) {
      fetchDoneRequests("filter");
    } else {
      fetchDoneRequests();
    }
  }, [rowsPerPage, page, props.status]);

  useEffect(() => {
    fetchListForMoverType();
    fetchTruckList();
  }, []);
  ////////////////////////////////////////////
  useEffect(() => {
    localStorage.setItem("directReqDoneFilter", JSON.stringify(filters));
    let date;
    if (filters.from_date !== "" && filters.to_date !== "") {
      date = `${moment(filters.from_date).format("ll")} to ${moment(
        filters.to_date
      ).format("ll")}`;
    } else {
      date = "";
    }
    let truck = truckList.map((truck) => {
      if (filters.truck_name == truck.id) {
        return truck.name;
      }
      return "";
    });
    props.setDoneFilterTitles([
      date,
      filters.schedule,
      filters.distance !== "" ? filters.distance + " miles" : filters.distance,
      filters.move_type,
      truck[0],
      filters.total_hours !== ""
        ? filters.total_hours + " hours"
        : filters.total_hours,
    ]);
  }, [filters, truckList]);
  //////////////////////////////////////////////////////////////////////

  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress ">
          <CircularProgress />
        </div>
      </>
    );
  }

  if (window.innerWidth < 500) {
    console.log(window.innerWidth, "Width");
    return (
      <>
        <div className="rounded-box pb-3">
          <div className="row">
            <div className="col-12">
              <table
                id="example"
                className="responsive table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <th className="small-sub-title dark-grey-color">
                    <div className="row">
                      <div className="col-6 small-sub-title dark-grey-color">
                        Done Requests
                      </div>
                      <div className="col-6">
                        {/* #{request.request_data.id} */}
                      </div>
                    </div>
                  </th>
                </thead>
                <tbody>
                  {requests.map((request, i) => (
                    <tr
                      key={request.foreman_requests.id}
                      className="pointer-point border-bottom"
                      onClick={() =>
                        props.history.push(
                          "/foreman/foreman-requests/" +
                            request.foreman_requests.id
                        )
                      }
                    >
                      <div className="row pl-2 mt-2">
                        <div className="col-4 small-sub-title dark-grey-color">
                          Request No.
                        </div>
                        <div className="col-8 small-sub-title dark-grey-color">
                          #{request.foreman_requests.id}
                          <span className="mr-2 float-right">
                            {request.foreman_requests.request_type && (
                              <span className="custom-chip">Direct</span>
                            )}
                          </span>
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Start date:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.schedule_time.slice(0, 11)}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Start time:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.schedule_time.slice(
                            11,
                            request.foreman_requests.schedule_time.length
                          )}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Distance:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.net_distance} mi
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Move Type:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.move_type}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Truck:</span>
                        </div>
                        <div className="col-8">
                          {request.trcuk_array.length === 0
                            ? "-"
                            : request.trcuk_array.map((truck, i) => {
                                return (
                                  truck.name +
                                  (i === request.trcuk_array.length - 1
                                    ? ""
                                    : ", ")
                                );
                              })}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Last update:</span>
                        </div>
                        <div className="col-8">
                          <span className="light-grey-color extra-small-font-size">
                            Updated{" "}
                            {moment(
                              request.foreman_requests.updated_at
                            ).fromNow()}
                          </span>
                        </div>
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={
                  <span className="pagination-text">Rows:</span>
                }
              />
            </div>
          </div>
        </div>
        <DoneRequestFilter
          filters={filters}
          setFilters={setFilters}
          moveSizeList={moveSizeList}
          truckList={truckList}
          setPage={setPage}
          fetchDoneRequests={fetchDoneRequests}
        />
      </>
    );
  }

  return (
    <>
      <div className="rounded-box pb-3">
        <div className="row">
          <div className="col-12">
            <table
              id="example"
              className="responsive table table-hover"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th className="small-sub-title dark-grey-color">
                    Request number
                  </th>
                  <th className="small-sub-title dark-grey-color">Date</th>
                  <th className="small-sub-title dark-grey-color">
                    Total hours
                  </th>
                  <th className="small-sub-title dark-grey-color">Distance</th>
                  <th className="small-sub-title dark-grey-color">Move Type</th>
                  <th className="small-sub-title dark-grey-color">Truck</th>

                  <th className="small-sub-title dark-grey-color"></th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request, i) => (
                  <tr
                    key={i}
                    className="pointer-point"
                    onClick={() =>
                      props.history.push(
                        "/foreman/foreman-requests/" +
                          request.foreman_requests.id
                      )
                    }
                  >
                    <td>
                      <span
                        href="request-detail-submitted.html"
                        className="request-link"
                      >
                        #{request.foreman_requests.id}
                        <span className="ml-3">
                          {request.foreman_requests.request_type && (
                            <span className="custom-chip">Direct</span>
                          )}
                        </span>
                        <br />
                        <span className="light-grey-color extra-small-font-size">
                          Updated{" "}
                          {moment(
                            request.foreman_requests.updated_at
                          ).fromNow()}
                        </span>
                      </span>
                    </td>
                    <td>
                      {request.foreman_requests.schedule_time.slice(0, 12)}
                      <br />
                      {/* 9:00 AM */}
                    </td>
                    <td>{getTotalHours(request.move_time)}</td>
                    <td>{request.foreman_requests.net_distance} mi</td>
                    <td>{request.foreman_requests.move_type}</td>
                    <td>
                      {request.trcuk_array.map(
                        (truck, i) =>
                          truck.name +
                          (i === request.trcuk_array.length - 1 ? "" : ", ")
                      )}
                    </td>
                    <td>
                      <a className="custom-btn-small custom-button-extra-small req-status-button active status-button-done">
                        Done
                      </a>
                    </td>
                  </tr>
                ))}
                {/* loop Close */}
              </tbody>
            </table>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={
                <span className="pagination-text">Rows per page:</span>
              }
            />
          </div>
        </div>
      </div>
      <DoneRequestFilter
        filters={filters}
        setFilters={setFilters}
        moveSizeList={moveSizeList}
        truckList={truckList}
        setPage={setPage}
        fetchDoneRequests={fetchDoneRequests}
      />
    </>
  );
}

export default withRouter(DoneRequests);
